<template>
  <div class="contract">
    <div class="tip">
      <p class="fontsize20" style="color: #ea5413;font-weight: bold;">
        {{information.company_name || info.name}}
      </p>
      <p>
        官网：<a :href="`http://${information.official_website || info.web}`" target="_blank">{{information.official_website || info.web}}</a>
      </p>
      <p>
        地址：{{information.company_address || info.location}}
      </p>
      <p>
        电话：{{information.company_phone || info.phone}}
      </p>
      <p>
        邮箱：{{information.company_email || info.email}}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'contract',
  data() {
    return {
      info: {
        name: '上海红柚信息技术有限公司',
        location: '中国上海市徐汇区钦州北路1188号科汇大厦1701室',
        web: 'www.honjoinfo.com',
        phone: '4008938068',
        email: 'info@honjomed.com'
      }
    }
  },
  computed: {
    ...mapGetters(['information'])
  }
}
</script>

<style lang="scss" scoped>
  .tip{
    padding: 8px 16px;
    background-color: #ecf8ff;
    border-radius: 4px;
    border-left: 5px solid #50bfff;
    margin: 20px 0;
    p {
      margin: 1em 0;
    }
  }
</style>